import { useParams } from 'react-router-dom';

export function CreditMemoPage() {
  const { caseId } = useParams();

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-navy mb-2">תיק פנימי — מסמך מו״מ</h1>
      <p className="text-slate-600 mb-8">Case: {caseId}</p>

      <div className="card">
        <p className="text-slate-600 mb-4">
          Phase 1 (Claude Code): יצירה אוטומטית של מסמך תיק פנימי על בסיס snapshot אחרון, כולל:
        </p>
        <ul className="list-disc mr-5 space-y-1 text-sm text-slate-600">
          <li>Executive Summary (סוכן AI מייצר)</li>
          <li>טבלת נתונים היסטוריים</li>
          <li>טבלת EBITDA/FCF/שנות החזר נורמטיביות</li>
          <li>ניתוח DSCR דינמי + גרף</li>
          <li>רשימת אתגרים וסיכונים (כמו בקובץ ב׳ של היועצת)</li>
          <li>המלצות למו״מ (סוכן AI מייצר)</li>
          <li>כפתור הורדה ב-PDF</li>
        </ul>

        <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-sm text-yellow-900">
            <strong>הערה קריטית:</strong> מסמך זה הוא כלי פנימי ליועץ בלבד. אינו מיועד להצגה ללקוח הקצה. כך הוגדר במפורש בשיחה עם היועצת.
          </p>
        </div>
      </div>
    </div>
  );
}
